export const trimFormValue = (value) =>
  typeof value === 'string' ? value.trim() : value

export const hasTrimmedValue = (value) =>
  typeof value === 'string' ? value.trim().length > 0 : Boolean(value)

/** Letters with optional spaces (e.g. first + middle name), hyphens, apostrophes */
export const PERSON_NAME_PATTERN = /^[a-zA-Z]+(?:[\s'-][a-zA-Z]+)*$/

export const personNamePatternRule = (fieldLabel = 'Name') => ({
  value: PERSON_NAME_PATTERN,
  message: `${fieldLabel} must contain only letters (spaces allowed for middle names)`,
})
